// * - ключ по которому происходит удаление маршрутов с карты в силу того, что у разных типов может быть одинаковый ID. Связка ID / Тип является уникальной
export const adapterModelRoutesForSelect = (routes) => {
  if (routes.length != 0) {
    return routes.map(i => {
      return {
        route_and_type: `${i.id}-${i.route_type.id}`, // *
        route_name_and_type: `${i.number}-${i.route_type.id}`, // *
        text: `${i.route_type.title} №${i.number}`,
        value: i.id,
        carrier: i.carrier,
        route_type: i.route_type.id,
        number: i.number,
        dtransport_id: i.dtransport_id
      }
    })
  } else {
    return routes
  }
}

export const adapterModelRoutesForMap = (routes, routes_by_rect) => {
  let result = []
  if (routes.length != 0) {
    // Находим полный объект с координатами и т.д.
    for (let i of routes_by_rect) {
      let route = routes.find(k => k.id == i.value && k.route_type.id == i.route_type)
      if (route != undefined) {
        result.push(route)
      }
    }
  }
  return result
}